import { Box } from '@chakra-ui/react'
import { authBackArrowColor } from './constants'

interface AuthBackButtonProps {
  onClick: () => void
  ariaLabel?: string
}

// Back arrow used by every auth page. On mobile it's pinned to the top-left
// of the viewport (independent of the form's vertical offset and any scroll),
// on desktop it stays in the top-left of the form column like before.
const AuthBackButton = ({ onClick, ariaLabel = 'Go back' }: AuthBackButtonProps) => (
  <Box
    as="span"
    role="button"
    aria-label={ariaLabel}
    onClick={onClick}
    position={{ base: 'fixed', lg: 'absolute' }}
    top={{ base: '8px', lg: '0' }}
    left={{ base: '8px', lg: '0' }}
    p="10px"
    fontSize="20px"
    lineHeight="1"
    color={authBackArrowColor}
    cursor="pointer"
    userSelect="none"
    zIndex={20}
    bg="transparent"
    border="none"
    _hover={{ opacity: 0.75 }}
  >
    ←
  </Box>
)

export default AuthBackButton
